const today = new Date()
const currentMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`

const reportsFiltersConfig = {
  altasBajas: {
    fields: [
      {
        id: 'period',
        label: 'Mes y año',
        type: 'month',
        query: {
          from: 'FechaDesde.gte',
          to: 'FechaHasta.lte'
        },
        defaultValue: currentMonth,
        fixed: true
      },
      {
        id: 'status',
        label: 'Movimiento',
        type: 'select',
        query: 'Estado.eq',
        defaultValue: '',
        clearable: true,
        placeholder: 'Altas y bajas',
        options: [
          { label: 'Altas', value: 'alta' },
          { label: 'Bajas', value: 'baja' }
        ]
      }
    ]
  }
}

export default reportsFiltersConfig
